
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/grievance-redressal-policy",
      function () {
        return require("private-next-pages/grievance-redressal-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/grievance-redressal-policy"])
      });
    }
  